const generalTab = {
  id: "general",
  label: "Общая статистика",
  component: "General",
};

const deliveredTab = {
  id: "delivered",
  label: "Доставка",
  component: "Delivery",
};

const errorsTab = {
  id: "errors",
  label: "Ошибки",
  component: "Errors",
};

const clickedTab = {
  id: "clicked",
  label: "Переходы",
  component: "clicked",
};

const opensTab = {
  id: "opens",
  label: "Открытия",
  component: "Opens",
};

const unsubscribersTab = {
  id: "unsubscribers",
  label: "Отписки",
  component: "Unsubscribes",
};

const clickMapTab = {
  id: "clickMap",
  label: "Карта кликов",
  component: "ClickMap",
};

const errorsTabLocked = {
  id: "errors",
  label: "Ошибки",
  component: "Errors",
  isLocked: true,
};

const smsTabs = [
  generalTab,
  deliveredTab,
  errorsTab,
];

const defaultTabs = [
  generalTab,
  deliveredTab,
  clickedTab,
  errorsTabLocked,
];

const pushTabs = [
  generalTab,
  deliveredTab,
  clickedTab,
  errorsTab,
];

const notificationTabs = [
  generalTab,
  opensTab,
  clickedTab,
  errorsTab,
];

const webpushTabs = [
  generalTab,
  deliveredTab,
  clickedTab,
  errorsTab,
];

const emailTabs = [
  generalTab,
  deliveredTab,
  opensTab,
  clickedTab,
  unsubscribersTab,
  clickMapTab,
];

const viberTabs = [
  generalTab,
  deliveredTab,
  opensTab,
  clickedTab,
];

const promotionsTabs = [
  generalTab,
];

export default {
  sms: smsTabs,
  email: emailTabs,
  viber: viberTabs,
  push: pushTabs,
  notification: notificationTabs,
  webpush: webpushTabs,
  default: defaultTabs,
  promotions: promotionsTabs,
};
